<template>
  <div>
    <div class="columns is-vcentered is-gapless is-border-bottom has-background-light is-marginless">
      <div class="column is-size-6 is-padding-top-small is-padding-bottom-small is-padding-left">
        <span class="has-text-weight-medium">{{ documents.length }} document(s)</span>
      </div>
      <div class="column is-narrow">
        <a
          v-if="checkedDocuments && checkedDocuments.length === 1"
          class="page-header-btn is-success is-small is-padding-left-small is-padding-right-small"
          target="_blank"
          :href="checkedDocuments[0].path"
          :download="checkedDocuments[0].filename">
          <span class="icon is-padding-right-xsmall">
            <i
              class="fas"
              :class="loading ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
          </span>
          <span class="has-text-weight-medium">Télécharger document</span>
        </a>
        <a
          v-if="checkedDocuments && checkedDocuments.length > 1"
          class="page-header-btn is-success is-small is-padding-left-small is-padding-right-small"
          @click="downloadDocuments">
          <span class="icon is-padding-right-xsmall">
            <i
              class="fas"
              :class="loading ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
          </span>
          <span class="has-text-weight-medium">Télécharger documents</span>
        </a>
      </div>
    </div>
    <table class="table is-fullwidth is-last-fixed-medium is-marginless has-cells-vcentered">
      <tbody class="is-size-6">
        <tr
          v-for="(d, i) in documents"
          :key="'tr' + i"
          class="is-size-6"
          :id="d.cloudinary_id">
          <td class="is-narrow">
            <span class="icon"><i class="fal fa-file-pdf"></i></span>
          </td>
          <td>
            <a
              target="_blank"
              :href="d.path"
              :download="d.filename">{{ d.filename }}</a>
          </td>
          <td class="has-text-right actions">
            <div class="dropdown is-hoverable is-right">
              <div class="dropdown-trigger">
                <button
                  class="button is-small is-circle is-action"
                  @click="selectDocument(d)"
                  :class="[{'':!isChecked(d), 'is-success':isChecked(d)}]">
                  <i class="fas fa-check"></i>
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DocumentList',
  props: {
    sourceDocuments: {
      type: Array,
      required: true
    },
    documentName: String
  },
  data () {
    return {
      checkedDocuments: [],
      loading: false
    }
  },
  computed: {
    documents () {
      return this.sourceDocuments
    }
  },
  methods: {
    async downloadDocuments () {
      try {
        await this.$api.post(this.$resources.EXPORT_FILES, { sources: this.checkedDocuments, download_name: this.documentName })
        this.$toasted.global.success('Vous allez recevoir vos fichiers par mail')
        this.checkedDocuments = []
      } catch (e) {
        this.$toasted.global.danger('Erreur lors du téléchargement des fichiers.')
      }
    },
    isChecked (d) {
      return this.checkedDocuments.map(x => x.cloudinary_id).includes(d.cloudinary_id)
    },
    selectDocument (document) {
      let idx = this.checkedDocuments.findIndex(x => x.cloudinary_id === document.cloudinary_id)
      if (idx >= 0) {
        this.checkedDocuments.splice(idx, 1)
      } else {
        this.checkedDocuments.push(document)
      }
    }
  }
}
</script>
